// const API_BASE_URL = "https://localhost:7122/api";
// const API_BASE_URL = "https://backendpde.eregistrationukgov.in/api";

// Set API_BASE_URL based on the environment
const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://backendpde.eregistrationukgov.in/api"
    : "https://localhost:7122/api";

const API_BASE_URL_CRYS =
  process.env.NODE_ENV === "production"
    ? "https://vreports.eregistrationukgov.in"
    : "https://localhost:44378";

const Google_url = "https://localhost:7125/api";
const Report_url =
  process.env.NODE_ENV === "production"
    ? "https://vreports.eregistrationukgov.in/Report/MyReport.aspx"
    : "https://localhost:44378/Report/MyReport.aspx";

const Webex_url =
  process.env.NODE_ENV === "production"
    ? "https://webex.eregistrationukgov.in/api"
    : "https://localhost:7186/api";
// const Webex_url = "https://webex.eregistrationukgov.in/api";
// const Webex_url = "https://localhost:7186/api";
export default API_BASE_URL;
export { Google_url };
export { Webex_url };
export { Report_url };
export { API_BASE_URL_CRYS };
